import React from 'react';
import { ThemeProvider } from 'styled-components';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Accueil from './page/Accueil.js'
import PrivateRoute from './PrivateRoute'
import PageLogin from './page/PageLogin.js';
import PageConsultation from './page/PageConsultation.js';
import PageElementsSearch from './page/PageElementsSearch.js';
import PageAssociation from './page/PageAssociation.js';
import PageEdit from './page/PageEdit.js';
import PageAdd from './page/PageAdd.js';
import PageDel from './page/PageDel.js';
import PageElement from './page/PageElement.js';
import PageElements from './page/PageElements.js';
import PageTest from './page/PageTest.js';
import PageNotFound from './page/PageNotFound.js';

const App = () => {

  return (
    <div className="App">
      <ThemeProvider
      theme={{
        colors: {
          fond: '#F4F4F4',
          texte: '#373737',
          texte_second: '#344D59',
          fond_menu:'#dbcab8',
          texte_menu:'#373737',
          contraste:'#ffffff',
          footer:'#373737',
          light:'#F4F4F4',
          dark:'#909090'
          },
          }}>
            <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<Accueil/>}/>
                    <Route exact path="/logout" element={<Accueil/>}/>
                    <Route exact path="/login" element={<PageLogin/>}/>
                    <Route exact path="/testGeo" element={<PageTest/>}/>
                    <Route exact path="/:typeElement" element={<PageConsultation/>}/>
                    <Route exact path="/search/:typeElement/:limit/:index" element={<PageElementsSearch/>}/>
                    <Route exact path="/liste/:typeElement/:limit/:index" element={<PageElements/>}/>
                    <Route exact path="/:typeElement/:id" element={<PageElement/>}/>
                    <Route exact path="/:typeElement/edit/:id" element={<PrivateRoute><PageEdit/></PrivateRoute>}/>
                    <Route exact path="/:typeElement/del/:id" element={<PrivateRoute><PageDel/></PrivateRoute>}/>
                    <Route exact path="/:typeElement/add" element={<PrivateRoute><PageAdd/></PrivateRoute>}/>
                    <Route exact path="/association/:typeElement/:id/:typeElementAAssocier"element={<PrivateRoute><PageAssociation/></PrivateRoute>}/>
                    <Route path="*" element={<PageNotFound/>} />
                </Routes>
            </BrowserRouter>
    </ThemeProvider>
    </div>

  )
}

export default App;
